import { Box, Button, List, ListItem } from "@mui/material";
import React, { useState } from "react";
import styles from "../../styles/components/copyRightDisputeModal.module.scss";
// import Image from 'next/image'
import assest from "../../json/assest";
import {
  addDotMiddle,
  concatAttachmentsDownloadPath,
  concatFileDownloadPath,
  getUtcDate,
  getUtcDateTime,
  openInNewTab,
  truncateString,
} from "../../lib/functions/utils.lib";

const CopyRightDisputeModal = ({ data }) => {
  // console.warn("data", data?.release_files);
  const [show, setShow] = useState(false);
  return (
    <Box className={styles.CopyRightModalWrapper}>
      <Box className={styles.copyRightItemBox}>
        <p>
          Released to: <b>{data.release_company}</b>
        </p>
        <p>
          Contact Date: <b>{getUtcDate(data.created_at)}</b>
        </p>
        <p>
          Removal Date: <b>{getUtcDateTime(data.release_date)}</b>
        </p>
      </Box>

      <Box className={styles.copyRightItemBox}>
        <h5>Note:</h5>
        <Box className={styles.copyRightItemBoxPara}>
          <p>
            <b>{truncateString(data.release_note, 120)}</b>
          </p>
        </Box>
        {data.release_note?.length >= 120 && (
          <Button onClick={() => setShow(true)}>Show more</Button>
        )}
        {show && (
          <Box className={styles.copyRightTxtShow}>
            <p>{data.release_note}</p>
            <Button onClick={() => setShow(false)} className={styles.closeBtn}>
              <img src={assest.crossIconPDF} width={9} height={9} alt="" />
            </Button>
          </Box>
        )}
      </Box>

      <Box className={styles.copyRightItemBox}>
        {data?.release_files?.length > 0 ? (
          <>
            <List>
              {data.release_files.map((file, i) => (
                <ListItem key={i}>
                  <p>{addDotMiddle(file.name, 20)}</p>
                  <Button
                    onClick={() =>
                      openInNewTab(concatAttachmentsDownloadPath(file.name))
                    }
                  >
                    <img
                      src={assest.downloadArrowIcon}
                      width={14}
                      height={14}
                      alt=""
                    />
                  </Button>
                </ListItem>
              ))}
            </List>
          </>
        ) : (
          <>
            <Box className={styles.noData}>
              <p>No files have been attached</p>
            </Box>
          </>
        )}
        {/* <List>
                    <ListItem>
                        <p>screenshot.png</p>
                        <img src={assest.downloadArrowIcon} width={14} height={14} alt='' />
                        <input type='file' />
                    </ListItem>
                    <ListItem>
                        <p>redacted_agrVH.pdf</p>
                        <img src={assest.downloadArrowIcon} width={14} height={14} alt='' />
                        <input type='file' />
                    </ListItem>
                    <ListItem>
                        <p>325007798_7afg....jpeg</p>
                        <img src={assest.downloadArrowIcon} width={14} height={14} alt='' />
                        <input type='file' />
                    </ListItem>
                </List> */}
      </Box>
    </Box>
  );
};

export default CopyRightDisputeModal;
